/* S ACTIVE — quick add on product cards (size buttons + Add to Cart) */
(function () {
  if (window.__saQuickAdd) return;
  window.__saQuickAdd = true;

  var TEXT = { pick: 'Select a size', adding: 'Adding…', added: 'Added ✓', error: 'Sorry, that could not be added. Please try again.' };

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function setMsg(box, text) {
    var m = box.querySelector('.sa-qa__msg');
    if (m) m.textContent = text || '';
  }

  /* The bag number in the header (there is one for desktop and one for mobile) */
  function syncBagCount(count) {
    document.querySelectorAll('.js-header-cart-item-count-wrapper').forEach(function (wrap) {
      wrap.setAttribute('data-cart-count', count);
      var num = wrap.querySelector('.js-header-cart-item-count');
      if (num) num.textContent = count;
    });
  }

  /* Open the cart with the new item in it, and update the bag number */
  function showCart() {
    var core = window.themeCore;
    var bus = core && core.EventBus;

    if (bus && document.getElementById('CartDrawer')) {
      /* re-draws the cart drawer from the server, then opens it */
      bus.emit('cart:drawer:refresh-and-open');
    } else if (bus && document.querySelector('[data-section-type="cart-template"]')) {
      bus.emit('cart:refresh');
    } else {
      window.location.href = root() + 'cart';
      return;
    }

    fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || typeof cart.item_count !== 'number') return;
        if (core) core.cartObject = cart;
        if (bus) bus.emit('header:update-item-count', { item_count: cart.item_count });
        syncBagCount(cart.item_count);
      })
      .catch(function () {});
  }

  function addToCart(id) {
    return fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok) throw j;
          return j;
        });
      })
      .then(function (j) {
        showCart();
        return j;
      });
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    /* choose a size */
    var size = e.target.closest('.sa-qa__size');
    if (size) {
      var sizeBox = size.closest('[data-sa-qa]');
      if (!sizeBox || size.disabled) return;
      e.preventDefault();
      sizeBox.querySelectorAll('.sa-qa__size').forEach(function (b) {
        var on = b === size;
        b.classList.toggle('is-selected', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      sizeBox.classList.remove('needs-size');
      setMsg(sizeBox, '');
      return;
    }

    /* add to cart */
    var btn = e.target.closest('[data-sa-qa-add]');
    if (!btn) return;
    var box = btn.closest('[data-sa-qa]');
    if (!box) return;
    e.preventDefault();
    if (btn.classList.contains('is-loading')) return;

    var chosen = box.querySelector('.sa-qa__size.is-selected');
    var id = btn.getAttribute('data-variant-id') || (chosen && chosen.getAttribute('data-variant-id'));

    if (!id) {
      box.classList.remove('needs-size');
      void box.offsetWidth; /* restart the nudge */
      box.classList.add('needs-size');
      setMsg(box, TEXT.pick);
      return;
    }

    var label = btn.getAttribute('data-label') || btn.textContent;
    btn.classList.remove('is-added');
    btn.classList.add('is-loading');
    btn.textContent = TEXT.adding;
    setMsg(box, '');

    addToCart(Number(id))
      .then(function () {
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        btn.textContent = TEXT.added;
        setTimeout(function () {
          btn.classList.remove('is-added');
          btn.textContent = label;
        }, 2200);
      })
      .catch(function (err) {
        btn.classList.remove('is-loading');
        btn.textContent = label;
        setMsg(box, (err && (err.description || err.message)) || TEXT.error);
      });
  });
})();
